module.exports = __webpack_public_path__ + "static/media/restricted_items.b74adb7c.jpg";